import { useLaunchDarklyToolbar } from '@launchdarkly/toolbar/react';
import { useFlags } from 'launchdarkly-react-client-sdk';

import { getEventInterceptionPlugin, getFlagOverridePlugin } from 'common/featureFlags/devToolbar';
import { getLDClientSideId, isLaunchDarklyConfigured } from 'common/featureFlags/launchDarkly';
import { LD_FLAG_ENABLE_DEV_TOOLBAR } from 'common/featureFlags/launchDarklyFlags';

/** Mounts the LaunchDarkly Developer Toolbar for any context targeted by the enable-dev-toolbar flag. */
export const useDevToolbar = (): void => {
    const flags = useFlags();
    const enabled = isLaunchDarklyConfigured() && Boolean(flags[LD_FLAG_ENABLE_DEV_TOOLBAR]);

    useLaunchDarklyToolbar({
        flagOverridePlugin: enabled ? getFlagOverridePlugin() : undefined,
        eventInterceptionPlugin: enabled ? getEventInterceptionPlugin() : undefined,
        clientSideId: getLDClientSideId(),
        position: 'bottom-left',
        enabled,
    });
};
